<template>
  <div class="qrcode-container" ref="qrcodeComponent">
    <img :src="src" class="qrcode-img" alt="二维码" />
  </div>
</template>
<script>
import QRCode from "qrcode";

export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      src: "",
    };
  },
  watch: {
    text(val) {
      if (!val) return;
      this.init()
    },
  },
  mounted(){
    this.init()
  },
  methods:{
    init(){
        if(!this.text)return
        QRCode.toDataURL(this.text)
        .then((url) => {
          this.src = url;
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.qrcode-container {
  height: 100%;
  width: 100%;
  .qrcode-img {
    width: 100%;
    height: 100%;
  }
}
</style>